import SupportTile from '../supportTile';
import Image from 'next/image';
import React from 'react';

export default function SupportColumn({manuals, title, thumbnail}) {

  const {alternativeText, height, width, formats} = thumbnail;

  return <section className={'flex flex-col gap-5'}>
    <div className={'h-32 relative'}>
      <Image
          src={formats.small.url}
          alt={alternativeText}
          // height={height}
          // width={width}
          layout={'fill'}
          objectFit={'scale-down'}
          quality={100}/>
    </div>
    <h2 className={'text-3xl uppercase font-bold text-gray-300'}>  {title}</h2>
    {Object.entries(manuals).map(([productTitle, manualList], index) => {

      return <div key={`MANUAL_${index}`} className={'flex flex-col gap-2'}>
        <h2
            className={'text-sm font-semibold font-title uppercase tracking-wide'}>{productTitle} </h2>
        {manualList.map(manual => {

          const {type, pdf, title, link, subTitle, subtitle} = manual;

          switch (type.toLowerCase()) {

            case 'document':
              return <SupportTile src={!!pdf ? pdf.url : null} text={title}
                                  subTitle={!!pdf ? pdf.caption : null}
                                  type={type.toLowerCase()}/>;

            case 'video_url':
              return <SupportTile src={link} text={title}
                                  subTitle={subtitle}
                                  type={type.toLowerCase()}/>;

          }

        })}
      </div>;

    })}
  </section>;

}
